module.exports = __webpack_public_path__ + "img/googleDw.e9cdb8ff.svg";